import React from "react"
import { SidebarLogo } from "../../Constant/images"

const FormHeaderLogo = ({ alt = "Wolcott Public Schools" }) => (
  <div className="flex flex-col items-center justify-center pt-5 pb-4 px-4 bg-white border-b border-gray-400 overflow-visible">
    <h1
      className="text-center text-[28px] leading-tight font-semibold text-[#333333]"
      style={{ fontFamily: "Georgia, 'Times New Roman', Times, serif" }}
    >
      Wolcott Public Schools
    </h1>
    <p
      className="text-center text-[15px] leading-snug text-[#444444] mt-1"
      style={{ fontFamily: "Georgia, 'Times New Roman', Times, serif" }}
    >
      1488 Woodtick Road · Wolcott, CT 06716
    </p>
    <p
      className="text-center text-[15px] leading-snug text-[#444444] mt-0.5 mb-3"
      style={{ fontFamily: "Georgia, 'Times New Roman', Times, serif" }}
    >
      Telephone: 203.879.8183 · Fax: 203.879.8182
    </p>
    <img
      src={SidebarLogo}
      alt={alt}
      className="w-[140px] h-[140px] object-contain rounded-full bg-black"
      crossOrigin="anonymous"
    />
    <div className="w-full h-[2px] bg-[#C41E3A] mt-4" aria-hidden="true" />
  </div>
)

export default FormHeaderLogo
